import ChangeEnvDrawer from 'components/drawers/change-env-drawer/change-env-drawer.component';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import EnvIcon from 'components/env-icon/env-icon.component';
import { isProduction } from 'util/getEnv';

const ChangeEnv = () => {
  const { open, setOpen, close } = useUtilityDrawer();

  const onEnvIconClick = () => {
    setOpen(true);
  };

  if (isProduction()) return null;

  return (
    <>
      <EnvIcon onClick={onEnvIconClick} />
      <ChangeEnvDrawer open={open} close={close} />
    </>
  );
};

export default ChangeEnv;
